import { ROUTE_ERROR_TEXT } from '../constants/RouteError.constants';

/**
 * Checks if the error is a chunk load error based on the error message or name.
 * @param error Error
 * @returns boolean
 */
export const getIsChunkError = (error: Error): boolean => {
  return (
    error.message?.includes(ROUTE_ERROR_TEXT.chunkLoadError.message) ||
    error.name === ROUTE_ERROR_TEXT.chunkLoadError.name
  );
};
